var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notificator no-select"},[_c('transition-group',{attrs:{"name":"slide-fade"}},_vm._l((_vm.list),function(item){return _c('div',{key:item.id,staticClass:"notificator--item",class:{
        not_danger: item.color == 'danger',
        not_success: item.color == 'success',
        not_info: item.color == 'info'
      }},[_c('div',{staticClass:"notificator--close",on:{"click":function($event){return _vm.removeNotification(item)}}},[_c('i',{staticClass:"fas fa-times"})]),_vm._v(" "+_vm._s(item.text)+" ")])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }